var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed, observe } from "mobx";
import { eBranches } from "sb-helpers";
import { SelectionType, ItemState, EventTextTypeModifiers, SuperBannerJackpotItem } from "../../../data";
import { DataParser } from "../../../parser";
import { modifierDatePeriodTimes, modifierTimeScore, textDatePeriodTime, textTimeScore, hasResolvedQAMarket, hasPickedCMSMarketAndNotResolvedYetMarket, showFreeHtml, hasEventStarted, hasEventLiveScoreboard, buildUIScoreboardData, getPagesCount, isNotLiveRacingEvent, getLeftArrowState, getRightArrowState } from "../helpers";
import { returnValueHelper, scrollLeft, scrollRight } from "../../../helpers";
export var ItemType;
(function (ItemType) {
    ItemType[ItemType["jackpotItem"] = 0] = "jackpotItem";
    ItemType[ItemType["sportItem"] = 1] = "sportItem";
})(ItemType || (ItemType = {}));
export class SuperBannerData {
    constructor(data) {
        this.getSuperBannerItemModifier = (item) => {
            var _a, _b;
            if (((_b = (_a = item.EventUIPops) === null || _a === void 0 ? void 0 : _a.pickedEvent.market) === null || _b === void 0 ? void 0 : _b.type) === SelectionType.QA) {
                return this.oddsFormatter.Outright.getOddsOrderClass(item.EventUIPops.pickedEvent.market.selections);
            }
            return "";
        };
        this.snap = (value) => {
            const step = this.calcs.step;
            return Math.round(value / step) * step;
        };
        // Auto loop start
        this.autoLoopPages = () => {
            let page = this.currentPage + 1;
            this.changePage(page < this.pages.length ?
                page :
                0);
            return this.autoLoopStart();
        };
        this.autoLoopStart = () => {
            this.autoLoopStop();
            if (this.isClicked) {
                return;
            }
            return this.autoLoopTimeout = window.setTimeout(this.autoLoopPages, this.provider.dataFacade.cms.UISetting.autoLoop.duration);
        };
        this.autoLoopStop = () => {
            clearTimeout(this.autoLoopTimeout);
            this.autoLoopTimeout = undefined;
        };
        this.provider = data.provider;
        this.oddsFormatter = data.oddsFormatHelper;
        this.items = [];
        this.disposeList = [];
        this.clientIncludeInManager = data.clientIncludeInManager;
        this.dict = data.dict;
        this.animation = {
            x: 0,
            duration: 0.35,
            ease: "back.out(0.7)"
        };
        this.scrollable = {
            left: false,
            right: false
        };
        this.isDragging = false;
        this.isClicked = false;
        this.items = this.provider.items;
        this.calcs = {
            step: 304,
            container: 0,
            wrapper: 0,
            multiplier: 1
        };
        this.pages = [];
        this.currentPage = 0;
        this.itemWidth = undefined;
        this.deviceDetect = data.provider.dataFacade.deviceDetectHelper.deviceDetect;
        this.statusesToDisplay = [ItemState.available, ItemState.loading];
        this.currentSelectedSportId = data.provider.currentSelectedSportId;
        this.disposeItemsChange = observe(this.provider, (change) => {
            let changedObject = change.object;
            this.updateCollection(changedObject);
        });
        this.disposeCurrentSelectedSportIdChange = observe(this.provider, "currentSelectedSportId", (change) => {
            this.updateCurrentSelectedSportId(change.newValue);
        });
    }
    updateCollection(change) {
        this.items = change.items;
    }
    updateCurrentSelectedSportId(sportId) {
        this.currentSelectedSportId = sportId;
    }
    get itemsToDisplay() {
        return this.items.filter(item => this.validateStatus(item) &&
            !(this.provider.dataFacade.cms.DisplayMobileMode && !item.PickedEvent)
            && this.isItemForCurrentSport(item)
            && isNotLiveRacingEvent(item));
    }
    get buildUIData() {
        return this.itemsToDisplay.map(item => {
            return item instanceof SuperBannerJackpotItem && this.buildJackpotItemUIData(item) || this.buildSportItemUIData(item);
        });
    }
    updateClientIncludeData() {
        this.items.forEach(item => item.ClientHashClass = this.clientIncludeInManager.getElementClass(item.ClientHashAttribute));
    }
    validateStatus(item) {
        return this.statusesToDisplay.indexOf(item.state) !== -1 &&
            (!item.PickedEvent || this.statusesToDisplay.indexOf(item.PickedEvent.state) !== -1);
    }
    isItemForCurrentSport(item) {
        return (this.currentSelectedSportId === item.SportId || item.SportId === 0);
    }
    setupCalcs(wrapper, container, displayMultipleItems) {
        this.calcs.wrapper = wrapper.offsetWidth;
        this.calcs.container = container.offsetWidth;
        !displayMultipleItems && this.setItemWidth(this.calcs.wrapper);
        let items = container.getElementsByClassName("rj-superbanner__item");
        if (items.length > 0) {
            let i = items[0].offsetWidth;
            let dI = i * items.length;
            let dC = (this.calcs.container - dI) / Math.max(items.length - 1, 1);
            this.calcs.step = i + dC;
        }
    }
    // Pagination start
    changePage(x) {
        this.setSlideMultiplier(Math.abs(x - this.currentPage));
        if (x > this.currentPage) {
            this.scrollRight();
        }
        else {
            this.scrollLeft();
        }
        this.updateCurrentPage(x);
        return x;
    }
    updatePagination() {
        let counter = getPagesCount(this.calcs);
        this.pages.length = counter;
        for (let i = 0; i < counter; i += 1) {
            this.pages[i] = {
                id: i,
                isCurrent: this.currentPage === i
            };
        }
    }
    updateCurrentPage(index) {
        this.pages = this.pages.map((page, i) => (Object.assign(Object.assign({}, page), { isCurrent: index === i })));
        this.currentPage = index;
        this.setSlideMultiplier(1);
    }
    setCurrentPage(inc) {
        this.currentPage = Math.max(Math.min(this.currentPage + inc, this.pages.length - 1), 0);
    }
    // Pagination end
    setSlideMultiplier(val) {
        this.calcs.multiplier = val;
    }
    addToSlipTranspiler(selection, bsUtilItems) {
        this.provider.addToSlipTranspiler(selection, bsUtilItems);
    }
    isImageWillDisplayed(event) {
        return event && (hasResolvedQAMarket(event) || hasPickedCMSMarketAndNotResolvedYetMarket(event)) ? true : false;
    }
    getImageHeight(item) {
        const event = item.PickedEvent;
        if (!this.provider.dataFacade.cms.DisplayMultipleItems && this.provider.dataFacade.deviceDetectHelper.deviceDetect.isDesktop) {
            return "220px";
        }
        if (event) {
            if (hasResolvedQAMarket(event) || hasPickedCMSMarketAndNotResolvedYetMarket(event)) {
                return "0px";
            }
            return "80px";
        }
        return "190px";
    }
    setItemWidth(w) {
        this.itemWidth = w;
    }
    buildJackpotItemUIData(item) {
        return {
            id: item.Id,
            ClientHashClass: item.ClientHashClass,
            ClientHashAttribute: item.ClientHashClass,
            isLoading: item.IsLoading,
            itemType: ItemType.jackpotItem,
            dict: this.dict,
            cmsConfig: item.cmsConfig,
            toggleAvailableState: item.toggleAvailableState,
        };
    }
    buildSportItemUIData(item) {
        var _a, _b;
        const ImageUIProps = {
            styles: {
                height: this.getImageHeight(item),
                width: "100%"
            },
            ImageSrc: (_a = item.Image) === null || _a === void 0 ? void 0 : _a.Src,
            ImageFallbackSrc: "/imgs/i/o/superbanner/fallback.svg",
            isMBNEnabled: this.provider.dataFacade.isMBNEnabled,
            iconWrapperCls: "rj-superbaner__icon",
            modifierLeague: [`img-${EventTextTypeModifiers.modifierLeague}`],
            link: "#",
            imageLink: item.Link,
            FreeHtmlText: item.FreeHtmlText,
            isLive: false,
            hasLivestream: false,
            shouldRemoveContent: this.isImageWillDisplayed(item.PickedEvent)
        };
        let UIData = {
            id: item.Id,
            ClientHashClass: item.ClientHashClass,
            ClientHashAttribute: item.ClientHashAttribute,
            isLoading: item.IsLoading,
            ImageUIProps,
            itemType: ItemType.sportItem
        };
        if (item.PickedEvent) {
            UIData = Object.assign(Object.assign({}, UIData), { ImageUIProps: Object.assign(Object.assign({}, ImageUIProps), { link: item.PickedEvent.Link || "#", leagueName: this.buildImgLeagueName(item.PickedEvent), isLive: !!((_b = item.PickedEvent.event) === null || _b === void 0 ? void 0 : _b.isLive), hasLivestream: item.PickedEvent.HasLivestream, FreeHtmlText: showFreeHtml(item.FreeHtmlText, item.PickedEvent.market) }), EventUIPops: this.buildEvenUIData(item.PickedEvent) });
        }
        return UIData;
    }
    buildImgLeagueName(pickedEvent) {
        var _a;
        const cms = this.provider.dataFacade.cms;
        const isSingleItemOrMobileView = (!cms.DisplayMultipleItems || cms.DisplayMobileMode);
        return !(isSingleItemOrMobileView || pickedEvent.IsOutright) && ((_a = pickedEvent.event) === null || _a === void 0 ? void 0 : _a.leagueName) || undefined;
    }
    buildEvenUIData(pickedEvent) {
        if (pickedEvent.event && pickedEvent.market) {
            const event = pickedEvent.event;
            const market = pickedEvent.market;
            const eventHasStarted = hasEventStarted(event);
            const hasPossession = eventHasStarted && event.sportID === eBranches.Tennis.toString();
            const possessionMdf = returnValueHelper(hasPossession, "possession", "");
            const outrightMdf = returnValueHelper(pickedEvent.IsOutright, "outright", "");
            const scoreboardProps = buildUIScoreboardData(event);
            const evenUIData = {
                boundOpenGameTranspiler: (e) => this.provider.openGameTranspiler(pickedEvent, e),
                pickedEvent,
                event,
                market,
                scoreboardProps: scoreboardProps.scoreboardProps,
                hasPossession,
                onService: scoreboardProps.onService,
                eventHasStarted,
                eventTextMdf: outrightMdf || possessionMdf,
                hasLiveScb: hasEventLiveScoreboard(event),
                isMobileView: this.provider.dataFacade.cms.DisplayMobileMode,
                liveIndicatorText: this.dict.LiveIndicator,
                modifierDatePeriodTimes: modifierDatePeriodTimes(event),
                modifierTimeScore: modifierTimeScore(event),
                textDatePeriodTime: textDatePeriodTime(event, this.dict),
                textTimeScore: textTimeScore(event),
                tags: market.tags,
                isMBNEnabled: this.provider.dataFacade.isMBNEnabled,
            };
            return evenUIData;
        }
        return;
    }
    setClicked(bool) {
        this.isClicked = bool;
    }
    setDragging(bool) {
        this.isDragging = bool;
    }
    setAnimationX(x) {
        this.animation.x = x;
    }
    // tslint:disable-next-line
    shouldScroll(nodes) {
        if (nodes.wrapper.current && nodes.container.current) {
            let sLeft = getLeftArrowState(this.animation.x);
            let sRight = getRightArrowState({
                wrapperWidth: this.calcs.wrapper,
                containerWidth: this.calcs.container,
                offset: this.animation.x
            });
            if (this.scrollable.left !== sLeft || this.scrollable.right !== sRight) {
                this.scrollable.left = sLeft;
                this.scrollable.right = sRight;
            }
        }
    }
    scrollLeft() {
        if (this.scrollable.left) {
            this.setAnimationX(scrollLeft(this.animation.x, this.calcs));
            this.setCurrentPage(-1);
        }
    }
    scrollRight() {
        if (this.scrollable.right) {
            this.setAnimationX(scrollRight(this.animation.x, this.calcs));
            this.setCurrentPage(1);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], SuperBannerData.prototype, "currentSelectedSportId", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SuperBannerData.prototype, "items", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SuperBannerData.prototype, "pages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SuperBannerData.prototype, "itemWidth", void 0);
__decorate([
    observable,
    __metadata("design:type", DataParser)
], SuperBannerData.prototype, "provider", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SuperBannerData.prototype, "animation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SuperBannerData.prototype, "scrollable", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SuperBannerData.prototype, "isDragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SuperBannerData.prototype, "isClicked", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SuperBannerData.prototype, "calcs", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DataParser]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateCollection", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateCurrentSelectedSportId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SuperBannerData.prototype, "itemsToDisplay", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], SuperBannerData.prototype, "buildUIData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateClientIncludeData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updatePagination", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateCurrentPage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "setItemWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "setClicked", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "setAnimationX", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "shouldScroll", null);
//# sourceMappingURL=SuperBannerData.js.map